import axios from 'axios'

// if(window.location.protocol === 'https:'){
//     const httpsagent = new https.Agent({
//         rejectUnauthorized : false
//     });

//     axios.defaults.httpAgent = httpsagent;
// }

const urlApis = {
    serverTramitesHacienda() {
      // console.log('serverTramitesHacienda');
        return  axios.create({ baseURL: 'https://evolucion.haciendachiapas.gob.mx/consumo_tramitesHacienda.php'})

    },
    serverAuthTramitesHacienda() {
        return  axios.create({ baseURL: 'https://evolucion.haciendachiapas.gob.mx/consumo_authHacienda.php'})
    },
    apiLogin(){
        return axios.create({ baseURL : 'http://200.57.183.210/SIFOSH/api/login/authenticate' })
    },
    apiFormatos(){
        //return axios.create({ baseURL : 'http://200.57.183.210/SIFOSH/api/formato' }) // <-- pruebas
        //return axios.create({ baseURL : 'http://172.31.9.3/SAF/api/formato' }) // <--produccion intranet
        return axios.create({ baseURL : 'https://presupuesto.haciendachiapas.gob.mx/SAF/api/formato' }) // <--produccion internet
        //unidades de apoyo->unidad de planeacion tiene resultados (interno)
        //tamb hay tramites externos
    },
    apiAuth(){
        return axios.create({ baseURL: 'https://evolucion.haciendachiapas.gob.mx:8083/key/api/Auth'})
    }
}


// API
// http://200.57.183.210/sifosh/api/formato/formatosExternos
export default urlApis;
